'use client';

import { SolflareWalletName } from '@solana/wallet-adapter-wallets';
import useCurrentWalletAdapter from './useCurrentWalletAdapter';

/**
 * Checks if the currently connected Solana wallet adapter is Solflare.
 */
const useIsSolflareWalletConnected = () => {
	const currentWallet = useCurrentWalletAdapter();

	return currentWallet.connected && currentWallet.name === SolflareWalletName;
};

export default useIsSolflareWalletConnected;
